/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {RomanEmpireBigWinCountUp} from "./RomanEmpireBigWinCountUp";
import {RomanEmpireBigWinView} from "./RomanEmpireBigWinView";
import {Timeline, TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";


export class RomanEmpireBigWinController extends StepCountUpBigWinController {

    private _gameView: RomanEmpireBigWinView;
    private readonly _winCountUp: RomanEmpireBigWinCountUp;
    private _isShakeAborted: boolean = false;
    private _shouldSkipLastSmallLevel : boolean = false;
    private _isReSpin : boolean = false;


    constructor(indexes: [number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : true, // false to fix #184
            skippableOnEachLevel: true
        });
        this._gameView = new RomanEmpireBigWinView();
        this._winCountUp = new RomanEmpireBigWinCountUp();
        this._winCountUp.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, GameConfig.instance.GAME_HEIGHT * 0.56);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected startWinPresentation(): void {
        super.startWinPresentation();
        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_BIG_WIN_ANIM_START));
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, SpinEvent.SKIP, () => {
            this._isShakeAborted = true;
            this._isPlaying=true;
        });
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        this._isReSpin = data.mode == RomanEmpireGameMode.GENIE_RESPIN;
        super.parseFeatureGameData(data);
    }

    protected getBigWinLevelAnimation(level: number): Timeline {
        return this._gameView.getBigWinLevelAnimation(this._winRatios[level], level);
    }

    protected playLocalCountUp(from: number, to: number, duration: number, preTotalWin: number = 0, level: number): Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration, level);
    }

    protected playEndingAnimation(isAborted: boolean): void {
        this._gameView.playEndingAnimation(this._winLevel, isAborted, this._isReSpin);
        SlotGame.winFieldController.showWinField();
        this._winCountUp.abort(this._gameData!.singleWin, isAborted);
    }

    protected playBigWinCountUp(level: number, duration: number): Timeline | null {
        const preTotalWin: number = this._gameData!.totalWin - this._gameData!.singleWin;
        const fromValue: number = level === 0 ? 0 : this._gameData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue: number = level === this._winLevel ? this._gameData!.singleWin : this._gameData!.playedBetValue * GameConfig.instance.WIN_RATIOS.bigWin[level + 1].ratio;
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            this.playLocalCountUp(fromValue, toValue, duration, preTotalWin, level),
            () => {
                if (this.playBigWinCountUpSound) {
                    this.playBigWinCountUpSound(level);
                }
            }
        ]);

        return timeline;
    }


    protected playBigWinLevelAnimation(currentLevel: number): void {
        // if(currentLevel == 0){
        //     SoundManager.fadeSound(this._isReSpin ? RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS : RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 50, 0);
        // }
        this._shouldSkipLastSmallLevel = this._skipLastLevelCountUpIfSmall && currentLevel === this._winLevel && this.isLevelWinTooSmall(currentLevel);
        super.playBigWinLevelAnimation(currentLevel);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return null;
    }
}